import { lazy } from 'react';

import { ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig from '../../../config/authConfig';
import { EmployeeDetailsStore } from '../store/employeeDetailsStore';
import { StatusHistoryStore } from '../store/statusHistoryStore';
import { ChangeReasonsStore, StatusHistoryDialogChangeReasonsStore } from '../store/changeReasonsStore';
import { EmploymentsStore, EmployeeEmploymentPeriodsStore } from '../store/employmentsStore';
import { ProjectsStore } from '../../Project/store/projectsStore';

export const EmployeeDetailsRoutes = {
  default: 'employees/:employeeId',
};

export const EmployeeDetailsPageConfig: ReactPageConfig = {
  name: 'src.components.employees.employeeDetails.pageConfig.name',
  path: EmployeeDetailsRoutes.default,
  allowedRoles: [ authConfig.roles.ADMIN ],
  component: lazy(() => import('../components/EmployeeDetailsPage')),
  storeDependencies: [
    { store: EmployeeDetailsStore },
    { store: StatusHistoryStore },
    { store: ChangeReasonsStore },
    { store: StatusHistoryDialogChangeReasonsStore },
    { store: EmploymentsStore },
    { store: EmployeeEmploymentPeriodsStore },
    { store: ProjectsStore },
  ],
  menuItemConfig: null,
};


